//////////////////////// DEPENDENCIES ////////////////////////

import React from 'react';
import { makeStyles, Grid, TextField, Typography, InputAdornment, Icon, Box } from '@material-ui/core';
import Button from '../../components/Button';
import { sendPasswordResetEmail } from '../../utils/authHelper' 

//////////////////////// COMPONENT ////////////////////////

function PasswordReset(props) {
  const cls = useStyles();

  const { open, setOpen, email, setEmail } = props;

  const [resetSuccess, setResetSuccess] = React.useState(null);

  const sendPasswordReset = async () => {
    try {
      const requestRes = await sendPasswordResetEmail('reset password', email, null);
      if (requestRes) {
        setResetSuccess(true);
      } else {
        setResetSuccess(false);
      }
    } catch (err) {
      console.error(`Error sending reset password email:`, err);
    }
  };

  return (
    <div>
      <Box mb={4} />

      <Typography className={cls.titleTxt}>Request or reset password</Typography>
      <Typography className={cls.subtitleTxt}>Enter your email and receive a link to reset your password.</Typography>

      <Box mb={3} />

      {resetSuccess === true ? (
        <>
          <Grid container alignItems='center'>
            <Grid item>
              <Icon className={cls.successIcon}>check_circle</Icon>
            </Grid>

            <Grid item xs>
              <Typography className={cls.successTxt}>
                Your request was sent successfully. Please check your email for the next step.
              </Typography>
            </Grid>
          </Grid>

          <Box mb={3} />

          <Button fullWidth onClick={() => setOpen(false)}>
            RETURN
          </Button>
        </>
      ) : resetSuccess === false ? (
        <>
          <Grid container alignItems='center'>
            <Grid item>
              <Icon className={cls.errorIcon}>cancel</Icon>
            </Grid>

            <Grid item xs>
              <Typography className={cls.errorTxt}>
                Your request failed to send. Please make sure your email is correct and try again.
              </Typography>
            </Grid>
          </Grid>

          <Box mb={3} />

          <Grid container spacing={2}>
            <Grid item xs>
              <Button fullWidth onClick={() => setOpen(false)}>
                CANCEL
              </Button>
            </Grid>

            <Grid item xs>
              <Button fullWidth color='primary' onClick={() => setResetSuccess(null)}>
                TRY AGAIN
              </Button>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <TextField
            required
            fullWidth
            autoFocus
            id='email'
            name='email'
            autoComplete='email'
            label='Email'
            placeholder='Enter email...'
            variant='outlined'
            size='small'
            className={cls.redFocusTextField}
            value={email}
            onChange={e => setEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment style={{ verticalAlign: 'top' }} position='start'>
                  <Icon color='disabled' fontSize='small'>
                    email
                  </Icon>
                </InputAdornment>
              ),
            }}
          />

          <Box mb={3} />

          <Grid container spacing={2}>
            <Grid item xs>
              <Button fullWidth onClick={() => setOpen(false)}>
                CANCEL
              </Button>
            </Grid>

            <Grid item xs>
              <Button
                disabled={!email || resetSuccess === false || resetSuccess === true}
                fullWidth
                type='submit'
                color='primary'
                onClick={() => sendPasswordReset()}
              >
                SUBMIT
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

//////////////////////// STYLES ////////////////////////

const useStyles = makeStyles(theme => ({
  titleTxt: {
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 500,
  },
  subtitleTxt: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 400,
  },
  successIcon: {
    marginRight: 8,
    fontSize: 24,
    color: `#30b448`,
  },
  successTxt: {
    verticalAlign: 'top',
    lineHeight: 1.333,
    fontSize: 18,
    color: `#30b448`,
  },
  errorIcon: {
    marginRight: 8,
    fontSize: 24,
    color: `#ff2040`,
  },
  errorTxt: {
    verticalAlign: 'top',
    lineHeight: 1.333,
    fontSize: 18,
    color: `#ff2040`,
  },
  redFocusTextField: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e94f37',
      borderWidth: 2,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#e94f37',
    },
    '& .MuiFormLabel-asterisk': {
      color: '#e94f37',
    },
  },
}));

//////////////////////// EXPORT ////////////////////////

export default PasswordReset;
